<div
    class="selected-installation flex flex-row items-center w-full px-10px sm:px-20px md:px-30px py-10px sm:py-20px border border-gray-300 rounded bg-white"
    [class.cursor-pointer]="canToggle"
    [class.container-expanded]="isExpanded"
    (click)="onToggle()"
>
    @if (selectedItem; as selected) {
        <div class="flex-grow">
            <app-selected-installation-cell
                [installation]="selected.selectedInstallation"
                [customerNumber]="selected.customerNumber"
            ></app-selected-installation-cell>
        </div>
    }
    @if (canToggle) {
        <div class="arrow-icon fg-green" [class.expanded]="isExpanded">
            <mat-icon svgIcon="evida_menu_arrow-solid"></mat-icon>
        </div>
    }
</div>
